
import type { Brand } from 'modules/products'

import type { FilterDictionary } from '../types'

import MobileFiltersModal from './MobileFiltersModal'
import MobileSortingModal from './MobileSortingModal'

import styles from './MobileFilters.module.scss'

interface FiltersProps {
  brands: Brand[]
  tags: FilterDictionary[]
  deliveryDates: string[]
}

const MobileFilters = ({ brands, tags, deliveryDates }: FiltersProps) => {
  return (
    <div className={styles.wrapper}>
      <MobileFiltersModal
        deliveryDates={deliveryDates}
        tags={tags}
        brands={brands}
      />
      <MobileSortingModal />
    </div>
  )
}

export default MobileFilters
